<template>
    <div>
        <template v-for="item in scope.row.authority">
            <template v-if="scope.row.authority.length <= 3">
                <el-button
                    type="text"
                    :class="item.class"
                    size="mini"
                    :disabled="!!item.disabled"
                    :key="item.id"
                    v-if="item.status_flag !== 4 && item.name != 'Message' || item.disabled"
                    @click="rowDo(item, scope.row)"
                    >{{ item.name }}</el-button
                >
                <remarkPopTable
                    v-else-if="item.name == 'Message'"
                    :key="item.id"
                    @rowDo="rowDo"
                    :item="{
                        ...item,
                        rowId: scope.row.id,
                        type: 'text',
                    }"
                ></remarkPopTable>
                <delPopConfirm
                    v-else
                    :key="item.id"
                    btnClassName="tableBtnShape"
                    :confirmButtonText="item.confirmButtonText || ''"
                    :cancelButtonText="item.cancelButtonText || ''"
                    :title="item.delTitle || ''"
                    :item="{
                        ...item,
                        rowId: scope.row.id,
                        type: 'text',
                    }"
                    :row="scope.row"
                    @rowDo="rowDo"
                ></delPopConfirm>
            </template>
            <el-button
                type="text"
                :class="item.class"
                size="mini"
                :key="item.id"
                v-if="scope.row.authority.length >= 4 && item.name == 'View'"
                @click="rowDo(item, scope.row)"
                >{{ item.name }}</el-button
            >
        </template>
        <template v-if="scope.row.authority.length >= 4">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    Operation<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-for="item in scope.row.authority"
                        :key="item.id"
                        @click.native="rowDo(item, scope.row)"
                    >
                        <el-button
                            type="text"
                            :class="item.class"
                            size="mini"
                            v-if="!['View', 'Message'].includes(item.name)"
                            >{{ item.name }}</el-button
                        >
                        <remarkPopTable
                            v-else-if="item.name == 'Message'"
                            :key="item.id"
                            @rowDo="rowDo"
                            :item="{
                                ...item,
                                rowId: scope.row.id,
                                type: 'text',
                            }"
                        ></remarkPopTable>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </template>
    </div>
</template>

<script>
import delPopConfirm from "@/common/components/table/delPopConfirm";
import remarkPopTable from "@/common/components/table/remarkPopTable";
export default {
    name: "Operation",
    props: {
        scope: Object,
    },
    components: {
        delPopConfirm,
        remarkPopTable,
    },
    methods: {
        rowDo(item, row) {
            this.$emit("rowDo", item, row);
        },
    },
};
</script>

<style>
</style>